import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests')({
  component: Outlet,
});
